<div class="container">
    <div class="text-center m-5">
        <h1>CrossTrend Analisi H1</h1>
    </div>

    <div class="row mt-5">
        <div class="col-2">
            <mdb-form-control>
                <mdb-select (valueChange)="cambiaMercato($event)" id="market">
                    <mdb-option *ngFor="let m of mercati" [value]="m.market">{{m.market}}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label" for="market">Mercato</label>
            </mdb-form-control>
        </div>
        <div class="col-2">
            <mdb-form-control>
                <mdb-select (valueChange)="minCrossTrendBuy($event)" id="minCTBuy">
                    <mdb-option *ngFor="let m of minCTBuy" [value]="m">{{m}}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label" for="market">Min Buy</label>
            </mdb-form-control>
        </div>
        <div class="col-2">
            <mdb-form-control>
                <mdb-select (valueChange)="minCrossTrendSell($event)" id="minCTBuy">
                    <mdb-option *ngFor="let m of minCTSell" [value]="m">{{m}}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label" for="market">Min Sell</label>
            </mdb-form-control>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
</div>